//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the state of NCOA */
export const Processed = {
    /** NotProcessed */
    NotProcessed: 0,

    /** Complete */
    Complete: 1,

    /** Manual Update Required */
    ManualUpdateRequired: 2,

    /** Manual update required or not processed */
    ManualUpdateRequiredOrNotProcessed: 3,

    /** All records */
    All: 4
} as const;

/** Represents the state of NCOA */
export const ProcessedDescription: Record<number, string> = {
    0: "Not Processed",

    1: "Complete",

    2: "Manual Update Required",

    3: "Manual Update Required Or Not Processed",

    4: "All"
};

/** Represents the state of NCOA */
export type Processed = typeof Processed[keyof typeof Processed];
